export const MILITARY_TYPE = {
  Active: 1,
  NationalGuard: 5,
  Reserver: 6
};

export const CIVILIAN_CODE = '1' satisfies string;
